import _actions_change_position from './_actions/change/position.js'
import _actions_change_filters from './_actions/change/filters.js'
import _actions_change_filter from './_actions/change/filter.js'
import _actions_change_column from './_actions/change/column.js'
import _actions_save from './_actions/save.js'
import _actions_reset from './_actions/reset.js'
import _actions_open from './_actions/open.js'
import _actions_get from './_actions/get.js'
import _actions_change from './_actions/change.js'
import _actions_cancel from './_actions/cancel.js'
import _getters_filters from './_getters/filters.js'
import _getters_default from './_getters/default.js'
import _getters_dateIntMax from './_getters/dateIntMax.js'
import _getters_data from './_getters/data.js'
import _getters_columns from './_getters/columns.js'
import _mutations_filter_set from './_mutations/filter/set.js'
import _mutations_filter_remove from './_mutations/filter/remove.js'
import _mutations_filter_add from './_mutations/filter/add.js'
import _mutations_set from './_mutations/set.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_data from './_mutations/data.js'
import _mutations_column from './_mutations/column.js'
import _mutations_cb from './_mutations/cb.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        cb: _mutations_cb,
        column: _mutations_column,
        data: _mutations_data,
        loading: _mutations_loading,
        set: _mutations_set,
        filter_add: _mutations_filter_add,
        filter_remove: _mutations_filter_remove,
        filter_set: _mutations_filter_set,
    },
    getters:{
        columns: _getters_columns,
        data: _getters_data,
        dateIntMax: _getters_dateIntMax,
        default: _getters_default,
        filters: _getters_filters,
    },
    actions:{
        cancel: _actions_cancel,
        change: _actions_change,
        get: _actions_get,
        open: _actions_open,
        reset: _actions_reset,
        save: _actions_save,
        change_column: _actions_change_column,
        change_filter: _actions_change_filter,
        change_filters: _actions_change_filters,
        change_position: _actions_change_position,
    },
}